import styled from "styled-components";
import { Link as LinkScroll } from "react-scroll";
import { Container } from "../../globalStyles";
import { pink, orange } from "../../Colors";
import { Link } from "react-router-dom";

export const Nav = styled.nav`
  background: ${({ background }) => (background ? "#000" : "transparent")};
  margin-bottom: -80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 999;

  transition: background-color 0.3s ease-in;
`;

export const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: start;
  height: 80px;

  ${Container}
`;

export const NavLogo = styled(Link)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  z-index: 100;
  margin-left: 1rem;
`;

export const NavIcon = styled.img`
  margin-right: 0.5rem;
  max-height: 2rem;
`;

export const LoginIcon = styled.div`
  display: none;
  z-index: 100;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0.5rem;
    right: 2rem;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const AvatarIcon = styled.div`
  display: none;
  z-index: 100;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: -0.2rem;
    right: 0rem;
    transform: translate(-100%, 60%);
    cursor: pointer;
  }

  img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid #737373;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }
`;

export const MobileIcon = styled.div`
  display: none;
  z-index: 100;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0.5rem;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  width: 100%;

  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    position: absolute;
    padding-top: 80px;
    top: ${({ show }) => (show ? 0 : "-100vh")};
    left: 0;
    opacity: 1;
    transition: all 0.5s ease;
    background: #000;
  }

  > li:first-child {
    margin-left: auto;
  }
`;

export const NavAnchor = styled.a`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #fed693;
  }

  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;
  }
`;

export const NavItem = styled.li`
  height: 80px;
  cursor: pointer;

  @media screen and (max-width: 960px) {
    width: 100%;

    &:hover {
      border: none;
    }
  }
`;

export const NavItemBtn = styled.li`
  display: flex;
  margin-left: auto;
  align-items: center;
  gap: 1rem;
  @media screen and (max-width: 960px) {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
  }

  button {
    background-color: transparent;
    border-radius: 5px;
    border: 2px solid ${orange};

    @media screen and (max-width: 960px) {
      width: 100%;
    }
  }
`;

export const NavLinks = styled(LinkScroll)`
  color: #fff;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  &.active {
    border-bottom: none;
  }
  &:hover {
    // border-bottom: 2px solid ${pink};
    border-bottom: none;
  }

  @media screen and (max-width: 960px) {
    text-align: center;
    padding: 2rem;
    width: 100%;
    display: table;

    &.active {
      border-bottom: none;
      background: linear-gradient(-45deg, #fed693, #ca7100);
    }

    &:hover {
      color: #fed693;
      //   transition: all 0.3s ease;
    }
  }
`;

export const ButtonLink = styled(LinkScroll)`
  color: inherit;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    outline: none;
  }
`;

export const NavBtnLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: 8px 16px;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
`;
